import React from "react";
import Admin from "./admin";



const Login = (props) => {

    const { email,
        setEmail,
        password,
        setPassword,
        handleLogin,
        handleSignup,
        setHasAccount,
        hasAccount,
        emailError,
        passwordError } = props;

    return (
        <section className="login">
            <div className="loginContainer">
          <img src='img/splash.png' height='200'></img>
                <label>Username</label>
                <input type="text"
                    autoFocus
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <p className="errorMsg">{emailError}</p>
                <label>Password</label>
                <input
                    type="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <p className="errorMsg">{passwordError}</p>
                <div className="btnContainer">
                    
                        
                            <button onClick={handleLogin}>Sign in</button>
                            
                        
                     

                </div>


            </div>
        </section>
    )


}
export default Login;